import * as areas from "./areas";
import * as people from "./people";
import * as transaction from "./transaction";
import * as units from "./units";

/*
  transactions

    assignPeopleToArea
    assignPeopleToUnit
    unassignPeople

    assignUnitsToArea
    unassignUnits

    addArea
    deleteArea
    renameArea
    unassignArea

*/

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */

export function addArea(areaType,areaId,areaName) {
  const task = {
    preparor: areas,
    areaType: areaType,
    areaId: areaId,
    areaName: areaName,
    addArea: true
  };
  return execute(task);
}

export function assignPeopleToArea(peopleFeatureItems,areaItem,areaType) {
  const task = {
    preparor: people,
    peopleFeatureItems: peopleFeatureItems,
    assignPeopleToArea: {
      areaItem: areaItem,
      areaType: areaType
    }
  };
  return execute(task);
}

export function assignPeopleToUnit(peopleFeatureItems,unitFeatureItem,unassignCurrentOccupants) {
  const task = {
    preparor: people,
    peopleFeatureItems: peopleFeatureItems,
    assignPeopleToUnit: {
      unitFeatureItem: unitFeatureItem,
      unassignCurrentOccupants: unassignCurrentOccupants
    }
  };
  return execute(task);
}

export function assignUnitsToArea(unitFeatureItems,areaItem,areaType) {
  const task = {
    preparor: units,
    unitFeatureItems: unitFeatureItems,
    assignUnitsToArea: {
      areaItem: areaItem,
      areaType: areaType
    }
  };
  return execute(task);
}

export function deleteArea(areaItem,areaType) {
  const task = {
    preparor: areas,
    areaItem: areaItem,
    areaType: areaType,
    unassignArea: true,
    deleteArea: true
  };
  return execute(task);
}

export function renameArea(areaItem,areaType,areaName) {
  const task = {
    preparor: areas,
    areaItem: areaItem,
    areaType: areaType,
    areaName: areaName,
    renameArea: true
  };
  return execute(task);
}

export function unassignArea(areaItem,areaType) {
  const task = {
    preparor: areas,
    areaItem: areaItem,
    areaType: areaType,
    unassignArea: true
  };
  return execute(task);
}

export function unassignPeople(peopleFeatureItems) {
  const task = {
    preparor: people,
    peopleFeatureItems: peopleFeatureItems,
    unassignPeople: true
  };
  return execute(task);
}

export function unassignUnits(unitFeatureItems) {
  const task = {
    preparor: units,
    unitFeatureItems: unitFeatureItems,
    unassignUnits: true
  };
  return execute(task);
}

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */

function execute(task) {
  return task.preparor.prepare(task).then(transactionInfo => {
    task.transactionInfo = transactionInfo;
    const edits = transactionInfo.edits;
    if (edits && edits.length > 0) {
      return transaction.applyEdits(task,transactionInfo);
    }
  });
}

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */
